function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';

var ArrowKeyListener = /*#__PURE__*/function (_React$Component) {
  _inherits(ArrowKeyListener, _React$Component);

  var _super = _createSuper(ArrowKeyListener);

  function ArrowKeyListener() {
    var _this;

    _classCallCheck(this, ArrowKeyListener);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      var _this$props = _this.props,
          onDown = _this$props.onDown,
          onUp = _this$props.onUp,
          onLeft = _this$props.onLeft,
          onRight = _this$props.onRight;

      switch (typeof event !== 'undefined' && event.key) {
        case 'ArrowDown':
          onDown(event);
          break;

        case 'ArrowUp':
          onUp(event);
          break;

        case 'ArrowLeft':
          onLeft(event);
          break;

        case 'ArrowRight':
          onRight(event);
          break;

        default:
          break;
        // Quit when this doesn't handle the key event.
      }
    });

    return _this;
  }

  _createClass(ArrowKeyListener, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = this.props.children;
      return /*#__PURE__*/React.createElement("span", {
        onKeyDown: function onKeyDown(e) {
          return _this2.handleKeyDown(e);
        },
        role: "presentation"
      }, children);
    }
  }]);

  return ArrowKeyListener;
}(React.Component);

_defineProperty(ArrowKeyListener, "propTypes", {
  children: PropTypes.node.isRequired,
  onUp: PropTypes.func,
  onDown: PropTypes.func,
  onLeft: PropTypes.func,
  onRight: PropTypes.func
});

_defineProperty(ArrowKeyListener, "defaultProps", {
  onUp: function onUp() {
    return false;
  },
  onDown: function onDown() {
    return false;
  },
  onLeft: function onLeft() {
    return false;
  },
  onRight: function onRight() {
    return false;
  }
});

ArrowKeyListener.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleKeyDown",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "ArrowKeyListener",
  "props": {
    "onUp": {
      "defaultValue": {
        "value": "() => false",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onDown": {
      "defaultValue": {
        "value": "() => false",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onLeft": {
      "defaultValue": {
        "value": "() => false",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onRight": {
      "defaultValue": {
        "value": "() => false",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    }
  }
};
export default ArrowKeyListener;